/* eslint-disable no-console */
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import styled from 'styled-components';
import { Modal, ModalBody } from 'reactstrap';

const Cover = styled.div`
  position: relative;
  left: -12px;
  height: 2px;
  top: -1px;
`;

const TimeTrackerCircle = styled.div`
  position: relative;
  top: calc(50% - 5px);
  left: -6px;
  -webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  border-radius: 12px;
  border: 1px solid rgb(51, 51, 51);
  width: 10px;
  height: 10px;
`;

const ContinuousTimeTracker = ({ scheduledTimes, heights, currentTimeAsMoment }) => {
  if (!scheduledTimes || !heights || scheduledTimes.length === 0 || !currentTimeAsMoment) {
    return null;
  }

  const currentTimestamp = currentTimeAsMoment.valueOf();
  let totalHeight = 0;
  let currentRowIndex = -1;
  const circlePositions = [];

  // Calculate total height and circle positions
  for (let i = 0; i < scheduledTimes.length; i++) {
    const item = scheduledTimes[i];
    const start = item.StartTimeAsMoment.valueOf();
    const end = item.EndTimeAsMoment.valueOf();

    if (currentTimestamp < start) {
      // Current time is before this row - stop
      break;
    } else if (currentTimestamp >= start && currentTimestamp <= end) {
      // Current time is within this row
      currentRowIndex = i;
      const elapsed = currentTimestamp - start;
      const total = end - start;
      const percentageInCurrentRow = elapsed / total;
      totalHeight += heights[i] * percentageInCurrentRow;
      break;
    } else {
      // Current time is after this row - add full height and mark for circle
      totalHeight += heights[i];

      // Add circle at the bottom of this completed row (not for passing periods)
      if (!item.isPassingPeriod) {
        const cumulativeHeight = heights.slice(0, i + 1).reduce((sum, h) => sum + h, 0);
        circlePositions.push({ top: cumulativeHeight, rowIndex: i });
      }
    }
  }

  // Don't render if we haven't reached any events yet
  if (totalHeight === 0 && currentRowIndex === -1) {
    return null;
  }

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: '50%',
        transform: 'translateX(-50%)',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 10,
        display: 'flex',
        width: 5,
      }}
    >
      {/* The continuous line */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 2,
          height: `${totalHeight}px`,
          borderLeft: '3px solid #0C7489',
          backgroundColor: 'transparent',
        }}
      />

      {/* Circles at row boundaries - positioned as siblings, not children */}
      {circlePositions.map(({ top, rowIndex }) => (
        <TimeTrackerCircle
          key={rowIndex}
          style={{
            alignSelf: 'center',
            // position: 'absolute',
            // top: `${top - 5}px`, // Center the 10px circle
            // left: '-5px', // Center on the line
            backgroundColor: 'rgb(12, 116, 137)',
          }}
        />
      ))}
    </div>
  );
};

const createTimeTracker = (heights, i, difference, color, coverBorder, needsPadding, isPassingPeriod) => {
  const padding = needsPadding ? '12px 0 0 20px' : 0;
  const hasStarted = difference && difference.height && difference.height !== 0;
  const backgroundColor = isPassingPeriod
    ? hasStarted
      ? 'rgb(12, 116, 137)'
      : '#f1f1f1'
    : hasStarted
      ? 'rgb(12, 116, 137)'
      : null;
  const borderColor = isPassingPeriod ? 'rgb(51, 51, 51)' : 'rgb(51, 51, 51)';

  return (
    <td style={{ padding, position: 'relative', overflow: 'visible', verticalAlign: 'top' }}>
      <div
        id={`time-tracker-${i}`}
        style={{
          display: 'flex',
          position: 'absolute',
          left: '50%',
          justifyContent: 'center',
          height: heights ? heights[i] + 'px' : 'auto',
          padding: 0,
          overflow: 'visible',
        }}
      >
        <div className="difference" style={difference} />
        {heights && heights[i] > 0 && <TimeTrackerCircle style={{ backgroundColor, borderColor }} />}
        <Cover style={{ border: coverBorder }} />
      </div>
    </td>
  );
};

// const PopupWithCloseButton = ({ closeOnDocumentClick, open, closeFunction, children }) => {
//   return (
//     <Popup closeOnDocumentClick={closeOnDocumentClick} open={open} onClose={() => closeFunction(false)}>
//       <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
//         <div onClick={() => closeFunction(false)} style={{ padding: '5px 10px 5px 10px', cursor: 'pointer' }}>
//           <FontAwesomeIcon icon={faTimes} />
//         </div>
//       </div>
//       {children}
//     </Popup>
//   );
// };
const PopupWithCloseButton = ({ closeOnDocumentClick, open, closeFunction, children, modalStyle, modalBodyStyle }) => {
  return (
    <Modal
      isOpen={open}
      toggle={() => closeFunction(false)}
      backdrop={closeOnDocumentClick ? true : 'static'}
      style={modalStyle ? modalStyle : null}
    >
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <div onClick={() => closeFunction(false)} style={{ padding: '5px 10px 5px 10px', cursor: 'pointer' }}>
          <FontAwesomeIcon icon={faTimes} />
        </div>
      </div>
      <ModalBody style={modalBodyStyle ? modalBodyStyle : null}>{children}</ModalBody>
    </Modal>
  );
};

const Circle = styled.div`
  position: absolute;
  bottom: 10%;
  right: 10px;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  border: 1px solid rgb(51, 51, 51);
  background-color: #cc0000;
  width: 30px;
  height: 30px;
`;

/* eslint-enable */

export { createTimeTracker, ContinuousTimeTracker, PopupWithCloseButton, Circle };
